import { createApp } from 'vue'
import { createPinia } from 'pinia'

// Ensure the tree styles are always available
import 'element-plus/es/components/base/style/css'
import 'element-plus/es/components/tree/style/css'
import 'element-plus/es/components/table/style/css'

import BuyerApp from '../src/buyer/components/BuyerApp.vue'
import router from '../src/buyer/router/index'
import vueConfig from '../src/lib/vueConfig'
import { piniaPlugin } from '../src/buyer/store/plugins'

import { client } from '@/v31-buyer/client.gen'
import { setupAuthInterceptor } from '../src/shared/auth/clientInterceptor'
import { setupErrorHandling } from '../src/shared/errorHandling'

client.setConfig({
  baseUrl: '/buyer/api/',
})

// Use centralized auth interceptor setup
setupAuthInterceptor(client)

if (import.meta.env.PROD) {
  // Production code remains unchanged
}

const buyerApp = createApp(BuyerApp)

setupErrorHandling(buyerApp)

const pinia = createPinia()
pinia.use(piniaPlugin)
buyerApp.use(pinia)

// Router guard configuration has been moved to router/index.ts
// No need for router.beforeEach here anymore

buyerApp.use(router)
vueConfig.initElement(buyerApp)

// Initialize the app only after verifying auth status
function initApp() {
  buyerApp.mount('#app')
}

initApp()
